import {getPaymentRequest} from "../Functions/ServerFunctions";
import {useEffect, useState} from "react";

export const useGetPayment = (paymentId) => {
    const [loading, setLoading] = useState(true);
    const [payment, setPayment] = useState({amount: 0, paid: 0});

    useEffect(() => {

        setLoading(true);
        getPaymentRequest(paymentId).then(response => {
            setPayment(response);
            setLoading(false);
        }).catch(e => {
            console.error(e)
            setLoading(false)
        })


    }, [paymentId]);

    return {loading, payment};
}
